export default "__VITE_ASSET__sSoKchWK__"